module.exports = __webpack_public_path__ + "img/ttb.8d70980d.png";